import _PageHeader_InnerOuterStyles from 'containers/Page/Header/_styles/_PageHeader_InnerOuterStyles'
import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import Stripes from 'components/Stripes'
import { EDIT_URL_PART } from 'constants/URL'
import { EVENT_URL_PART } from 'pages/Event/_containers/Event/_constants/EVENT_URLS'
import _PageHeader_Styled from './_PageHeader_Styled'
import _PageHeader_defaultProps from './_PageHeader_defaultProps'
import _PageHeader_propTypes from './_PageHeader_propTypes'
import _PageHeader_Inner from './_styles/_PageHeader_Inner'
import _PageHeader_Logo from './_components/Logo/_PageHeader_Logo'
import _PageHeader_Loadable from 'containers/Page/Header/_PageHeader_Loadable'
import _Page_Header_User from 'containers/Page/Header/_components/User/_Page_Header_User'
import _PageHeader_Nav from 'containers/Page/Header/_components/Nav/_PageHeader_Nav'
import SportVokrugPlusPromo from 'containers/Page/Header/_components/SportVokrugPlusPromo/SportVokrugPlusPromo'

export const is_event_edit_path = (pathname = '') => {
  const path_parts = pathname.split('/').filter(Boolean)

  return path_parts.some((path_part, index) => (
    path_part === EVENT_URL_PART
    && /^\d+$/.test(path_parts[index + 1])
    && path_parts[index + 2] === EDIT_URL_PART
  ))
}

export class PageHeader extends PureComponent {

  render() {
    const pathname = this.props.location?.pathname
      || (typeof window !== 'undefined' ? window.location.pathname : '')
    const is_page_header_widget = this.props.react_widget
    const show_main_page_nav = is_page_header_widget &&
      pathname.replace(/\/+$/, '') === ''
    const show_sport_vokrug_plus_promo = !show_main_page_nav && !is_event_edit_path(pathname)

    return (
      <_PageHeader_Styled>

        <_PageHeader_InnerOuterStyles>
          <_PageHeader_Inner
            data-testid="page-header-inner"
            has_main_page_nav={show_main_page_nav}
          >
            <_PageHeader_Logo />
            {show_main_page_nav && <_PageHeader_Nav />}
            {show_sport_vokrug_plus_promo && <SportVokrugPlusPromo />}
            <_Page_Header_User {...this.props} />
          </_PageHeader_Inner>
        </_PageHeader_InnerOuterStyles>

        <Stripes />

      </_PageHeader_Styled>
    )
  }

  static Loadable = _PageHeader_Loadable
  static Styled = _PageHeader_Styled
  static defaultProps = _PageHeader_defaultProps
  static propTypes = _PageHeader_propTypes

}

export default withRouter(PageHeader)
